
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export async function clientCallAPI<T>(
  path: string,
  options: RequestInit = {},
): Promise<any> {


  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Accept-Language": 'vi',
      ...(options?.headers || {})
    }
  });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(`HTTP ${response.status} ${response.statusText} ${message}`);
  }

  return response.json() as Promise<T>;
}

